import useSiteTranslation from '@/providers/i18n/hooks/useSiteTranslation';
import { PAGE_TEXTS_KEYS } from '../../../../../../../constants/constant';
import { Button } from '../../../../ui/button';
import { CardContent } from '../../../../ui/card';
import InputField from '../../../../ui/customInput/input';
const Index = ({
  FORM_FIELD_SPECS,
  selectedSearchType,
  searchParams,
  errors,
  register,
  resetFormOnInteraction,
  formWrapperKey,
  setFormWrapperKey,
  setSearchParams,
}: any) => {
  const Texts = useSiteTranslation(PAGE_TEXTS_KEYS?.customerAndOrderSearch);
  return (
    <CardContent className="space-y-2 lg:pr-0">
      <div className="flex w-full" key={formWrapperKey?.[FORM_FIELD_SPECS?.orderId?.id]}>
        <InputField
          items={`${Texts?.orderId}`}
          id={FORM_FIELD_SPECS?.orderId?.id}
          htmlFor={FORM_FIELD_SPECS?.orderId?.id}
          register={register}
          errors={errors}
          label={Texts?.orderId}
          classname="w-full"
          rules={{
            required: Texts?.orderIdRequired,
          }}
          defaultValue={searchParams?.[FORM_FIELD_SPECS?.orderId?.id]}
          maxLength={FORM_FIELD_SPECS?.orderId?.maxLength}
          hideError
          isNum
          onChange={() => {
            resetFormOnInteraction();
            setSearchParams({ ...searchParams, [FORM_FIELD_SPECS?.confirmationId?.id]: '' });
            setFormWrapperKey({
              ...formWrapperKey,
              [FORM_FIELD_SPECS?.confirmationId?.id]: `key_${selectedSearchType}_${
                FORM_FIELD_SPECS?.confirmationId?.id
              }_${Math.floor(Date.now())}}`,
            });
          }}
        />
        <Button className="ml-5 h-auto bg-[#002C4E] px-8 text-18 text-white" type="submit">
          <span className="text-lg font-semibold text-white">{Texts?.searchButtonText}</span>
        </Button>
      </div>
      {errors?.[FORM_FIELD_SPECS?.orderId?.id] && (
        <p className="mt-2 text-sm text-scarletRed">{errors[FORM_FIELD_SPECS?.orderId?.id]?.message}</p>
      )}
      <p className="text-14 font-normal text-[#222222]">{Texts?.orderIdIdHelp}</p>
    </CardContent>
  );
};

export default Index;
